import { render, staticRenderFns } from "./stableIncome.vue?vue&type=template&id=9460a1d2&scoped=true&"
import script from "./stableIncome.vue?vue&type=script&lang=js&"
export * from "./stableIncome.vue?vue&type=script&lang=js&"
import style0 from "./stableIncome.vue?vue&type=style&index=0&id=9460a1d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9460a1d2",
  null
  
)

export default component.exports